<!-- 本科-个人信息页 -->
<template>
  <div class='personal-info'>
    <!--基本信息-->
    <personal-base />
    <!--自我介绍信息-->
    <personal-introduction />
    <!--支付信息-->
    <personal-payment />
  </div>
</template>

<script>
import personalBase from './components/personal-base'
import personalIntroduction from './components/personal-introduction'
import personalPayment from './components/personal-payment'
export default {
  name: '',
  components: {
    personalBase,
    personalIntroduction,
    personalPayment
  },
  data () {
    return {}
  },
  computed: {},
  mounted () {
  },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
